export const CRYPTO_FUNDING_ACCOUNT_SELECTOR_TEST_ID =
  'crypto_funding_account-select';
export const CRYPTO_FUNDING_WIDGET_TEST_ID = 'crypto_funding_widget';
export const CRYPTO_FUNDING_HISTORY_PANEL_TEST_ID =
  'crypto_funding_history_panel';
export const CRYPTO_FUNDING_CONTROL_PANEL_TEST_ID =
  'crypto_funding_control_panel';
export const CRYPTO_FUNDING_NO_ELIGIBLE_ACCOUNTS_TEST_ID =
  'crypto_funding_no-eligible-accounts';
